/* Move the personalisation panel inside the add-to-cart form.

   Horizon renders a theme block wherever the template puts it, but the
   /cart/add form is built by the buy-buttons block alone. A `properties[...]`
   input outside that form is never submitted — the field looks filled in, the
   order arrives blank, and nothing anywhere reports an error.

   Relocating the panel (rather than mirroring its values into hidden inputs)
   keeps native `required` validation working: the browser blocks the submit
   itself, before any theme JS runs. */
(function () {
  var PANEL = '.sv-perso';
  var FORM = 'form[action*="/cart/add"]';

  function place() {
    var panel = document.querySelector(PANEL);
    var form = document.querySelector(FORM);
    if (!panel || !form || form.contains(panel)) return;
    // top of the form puts it directly above quantity and the button, which is
    // where the template already positioned it visually
    form.insertBefore(panel, form.firstChild);
  }

  function watch() {
    place();
    // the product section re-renders on every variant change, which rebuilds
    // the panel outside the form again
    var host = document.querySelector('.product-information') || document.body;
    new MutationObserver(function () { place(); })
      .observe(host, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
